const ctaBarFormData = [
  {
    name: 'firstName',
    type: 'text',
    label: 'First Name',
    validators: ['alphaNumericValidator'],
    submitError: 'Please enter your first name using only letters, numbers, spaces, and dashes',
  },
  {
    name: 'lastName',
    type: 'text',
    label: 'Last Name',
    validators: ['alphaNumericValidator'],
    submitError: 'Please enter your last name using only letters, numbers, spaces, and dashes',
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone',
    validators: ['telValidator'],
    submitError: 'Please enter your phone number in a valid format',
  },
  // email field is set to type text so it's marked as valid when anything is entered
  // still won't submit if it doesn't pass validation, this is done so the label shifts when something is entered and doesn't reset
  {
    name: 'email',
    type: 'type',
    label: 'Email Address',
    validators: ['emailValidator'],
    submitError: 'Please enter your email address in a valid format',
  },
  {
    name: 'purpose',
    type: 'select',
    label: 'Loan Purpose',
    validators: ['dropdownValidator'],
    submitError: 'Please select the loan purpose',
  },
];

export default ctaBarFormData;
